
import * as Yup from "yup";
import { GroupType, SelectedUser } from "../../slices/users/types";
import { UserStatus } from "./models/User";
import { getUserTypeId } from "../../utils";

export enum UserDestination {
    USERS = "/users/",
    ACCOUNTS =  "/accounts/"
}

export const userEditForm = {
      firstName: "",
      lastName: "",
      mobileNumber: "",
      state: null as null | { value: string; label: string },
      jobTitle: "",
      note: "",
      email: "",
    }

export const userEditValidationSchema = Yup.object().shape({
  firstName: Yup.string().required("Please enter first name"),
  lastName: Yup.string().required("Please enter last name"),
  mobileNumber: Yup.string().required("Please enter mobile number"),
  state: Yup.object().nullable().required("Please select a state"),
  jobTitle: Yup.string().required("Please enter job title"),
  note: Yup.string(),
});

export const getUserType = (type: GroupType | string) => getUserTypeId(type);

export const buildUserPayload = (selectedUser: SelectedUser, values: any) => ({
  id: selectedUser?.id,
  email: selectedUser?.email,
  firstName: values.firstName,
  lastName: values.lastName,
  mobileNumber: values.mobileNumber,
  jobTitle: values.jobTitle,
  companyName: selectedUser?.companyName,
  note: values.note,
  state:
    typeof values.state.value === "number"
      ? values.state.value
      : values.state.value === UserStatus.Active
      ? 2
      : 3,
  type: getUserType(selectedUser?.type),
});

export const buildCustomerPayload = (selectedUser: SelectedUser, values: any, id: number) => ({
  id,
  email: selectedUser?.email,
  firstName: values.firstName,
  lastName: values.lastName,
  mobileNumber: values.mobileNumber,
  jobTitle: values.jobTitle,
  companyName: selectedUser?.companyName,
  userNote: values.note,
  requestNote: values.note,
  requestStatus: values.state.value,
  type: getUserType(selectedUser?.type),
});